import React from 'react';
import Icon from '@/components/ui/Icon';
import Text from '@/components/ui/Text';
import I18n from '@/modules/i18n';

interface ViewOnlyBannerProps {
  onDismiss: () => void;
}

const BOX = 'tw-mb-6 tw-flex tw-items-center tw-gap-3 tw-rounded tw-border tw-border-solid '
  + 'tw-border-teal-blue tw-bg-teal-blue/10 tw-px-4 tw-py-3 tw-text-tci-black';

// Reset the native button chrome (the tw- prefix means preflight doesn't) to a bare icon button.
const DISMISS = 'tw-ml-auto tw-shrink-0 tw-cursor-pointer tw-appearance-none tw-border-0 '
  + 'tw-bg-transparent tw-p-0 tw-leading-none';

const ViewOnlyBanner = ({ onDismiss }: ViewOnlyBannerProps) => (
  <div className={BOX}>
    <Icon className="tw-shrink-0" icon="InfoAlternate" size={24} />
    <Text size="sm" tag="span">{I18n.t('ai_features_view_only_banner')}</Text>
    <button aria-label={I18n.t('close')} className={DISMISS} type="button" onClick={onDismiss}>
      <Icon icon="Close" size={12} />
    </button>
  </div>
);

export default ViewOnlyBanner;
